import { render, staticRenderFns } from "./ForumItemSearchForum.vue?vue&type=template&id=e6ce8386&scoped=true"
import script from "./ForumItemSearchForum.vue?vue&type=script&lang=js"
export * from "./ForumItemSearchForum.vue?vue&type=script&lang=js"
import style0 from "./ForumItemSearchForum.vue?vue&type=style&index=0&id=e6ce8386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ce8386",
  null
  
)

export default component.exports